const isAnyKeys = (obj) => !!Object.keys(obj).length;
const objMap = (obj, func) => Object.keys(obj).map((name) => func(obj[name], name));
const objectKeysToLowerCase = (input) => {
    if (typeof input !== 'object') return input;
    if (Array.isArray(input)) return input.map(objectKeysToLowerCase);
    return Object.keys(input).reduce(function (newObj, key) {
        const val = input[key];
        const newVal = typeof val === 'object' && val !== null ? objectKeysToLowerCase(val) : val;
        const keyName = key.charAt(0).toLowerCase() + key.slice(1);

        newObj[keyName] = newVal;
        return newObj;
    }, {});
};

const isNullOrUndefined = (value) => value === null || value === undefined;

const filterKeysByValue = (obj, value) => {
    return Object.keys(obj).reduce((acc, key) => {
        if (obj[key] === value) {
            acc[key] = obj[key];
        }
        return acc;
    }, {});
};

export default {
    isAnyKeys,
    objMap,
    objectKeysToLowerCase,
    isNullOrUndefined,
    filterKeysByValue,
};
